export default __webpack_public_path__ + "static/media/account.138186cf.svg";